import React, { useRef, useState, useEffect } from "react";
import "../../../styles/PetsInfo.scss";
import { ReactComponent as Back } from "../../../assets/icons/back.svg";
import AddImage from "../../../assets/images/addAnimal.png";
import { useNavigate, useParams } from "react-router-dom";
import {
  ADD_PET_FILE,
  GET_DOWNLOAD_FILE_URL,
  GET_PET_FILE_URL,
  GET_PET_URL,
} from "../../../helper/Url";
import { AXIOS_GET } from "../../../config/axios";
import { toast, ToastContainer } from "react-toastify";
import styled from "styled-components";
import Translate from "../../../config/Translate";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/drag-drop/dist/style.css";
import "@uppy/provider-views/dist/style.css";
import FileSaver from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import { ReactComponent as Edit } from "../../../assets/icons/edit.svg";
import Uppy from "@uppy/core";
import Webcam from "@uppy/webcam";
import GoogleDrive from "@uppy/google-drive";
import Dropbox from "@uppy/dropbox";
import { Dashboard } from "@uppy/react";
import Url from "@uppy/url";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/drag-drop/dist/style.css";
import "@uppy/provider-views/dist/style.css";
import XHRUpload from "@uppy/xhr-upload";
import { Base_Url } from "../../../config/variables";
import { useDispatch, useSelector } from "react-redux";
import { selectLanguage } from "../../../features/LanguageSlice";
import { PetViewRecord } from "../../../features/ShowAccountSlice";

const AddNew = () => {
  const [isFile, setisFile] = useState(false);
  const navigate = useNavigate();
  const [PhotoFd, setPhotoFd] = useState(null);
  const [imgUrlPrev, setimgUrlPrev] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const [filesData, setfilesData] = useState([]);
  const token = JSON.parse(localStorage.getItem("token"))?.access_token;
  const [petType, setpetType] = useState(0);
  const [IsInsured, setIsInsured] = useState(false);
  const [isDownload, setisDownload] = useState(false);
  const [petDataResponse, setpetDataResponse] = useState([]);
  const languageValue = useSelector(selectLanguage);
  const [refName, setrefName] = useState();
  const [refBirth, setrefBirth] = useState();
  const [refType, setrefType] = useState();
  const [refBreed, setrefBreed] = useState();
  const [refSex, setrefSex] = useState();
  const [refColor, setrefColor] = useState();
  const [refmicroship, setrefmicroship] = useState();
  const [refIdentDate, setrefIdentDate] = useState();
  const [refWeight, setrefWeight] = useState();
  const [refAliName, setrefAliName] = useState();
  const [refVacine, setrefVacine] = useState();
  const [refRage, setrefRage] = useState();
  const [refInsurance, setrefInsurance] = useState();
  const [refgoOutSide, setrefgoOutSide] = useState();
  const [refisInsured, setrefisInsured] = useState();
const [uppy, setUppy] = useState(null);
const [refsterilise, setrefsterilise] = useState();
const dispatch = useDispatch();
let hostname = window.location.hostname.split(".").slice(-2).join(".");
const getUploadUrl = (e) => {
  const [file] = e.target.files;
  if (file) {
    setPhotoFd(file);
    setimgUrlPrev(URL.createObjectURL(file));
  }
};

useEffect(() => {
  const uppyInstance = new Uppy({
    meta: { type: "document" },
    restrictions: {
      maxFileSize: 4 * 1024 * 1024,
      allowedFileTypes: [".pdf", ".doc", ".docx"],
    },
    locale: {
      strings: {
        dropPasteFiles:
          languageValue === "En"
            ? "Put your files here, they will be uploaded and sent to the clinic or %{browseFiles}"
            : "Déposez vos fichiers, ils seront téléchargés et envoyés à la la clinique ou %{browseFiles}",
        browseFiles: languageValue === "En" ? "browse" : "parcourir",
      },
    },
  });

  uppyInstance.use(Webcam);
  
  // Remove problematic plugins temporarily
  // uppyInstance.use(Dropbox, {
  //   companionUrl: Base_Url,
  // });
  // uppyInstance.use(GoogleDrive, {
  //   companionUrl: Base_Url,
  // });
  
  uppyInstance.use(Url, { companionUrl: Base_Url });
  
  uppyInstance.use(XHRUpload, {
    endpoint: `${ADD_PET_FILE}${encodeURIComponent(id)}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  
  uppyInstance.on("complete", (result) => {
    setTimeout(() => {
      backPage();
    }, 4000);
  });
  
  setUppy(uppyInstance);

  return () => {
    if (uppyInstance && typeof uppyInstance.close === 'function') {
      uppyInstance.close();
    }
  };
}, [languageValue, id, token]);
  const getpetDadata = () => {
    setIsLoading(true);
    AXIOS_GET(`${GET_PET_URL}${id}`, token)
      .then((res) => {
        if (res.data.data) {
          setpetDataResponse(res.data.data);
          setimgUrlPrev(res.data.data.web_image);
          setIsInsured(res.data.data.insurance_desc);

          setrefName(res.data.data.name ? res.data.data.name : "N/A");
          dispatch(
            PetViewRecord({
              id,
              petname: res.data.data.name ? res.data.data.name : "N/A",
            })
          );
          setrefBirth(
            res.data.data.birth_date
              ? res.data.data.birth_date.replace(
                  /(\d\d)\/(\d\d)\/(\d{4})/,
                  "$3-$1-$2"
                )
              : ""
          );
          setrefIdentDate(
            res.data.data.identification_date
              ? res.data.data.identification_date.replace(
                  /(\d\d)\/(\d\d)\/(\d{4})/,
                  "$3-$1-$2"
                )
              : ""
          );
          setrefVacine(
            res.data.data.relance_maladies
              ? res.data.data.relance_maladies.replace(
                  /(\d\d)\/(\d\d)\/(\d{4})/,
                  "$3-$1-$2"
                )
              : ""
          );
          setrefRage(
            res.data.data.relance_rage
              ? res.data.data.relance_rage.replace(
                  /(\d\d)\/(\d\d)\/(\d{4})/,
                  "$3-$1-$2"
                )
              : ""
          );
          setrefisInsured(
            res.data.data.insurance_desc ? res.data.data.insurance_desc : "NON"
          );
          setrefType(res.data.data.species ? res.data.data.species : "N/A");
          setpetType(refType);
          setrefBreed(res.data.data.race ? res.data.data.race : "N/A");
          setrefSex(res.data.data.sex ? res.data.data.sex : "N/A");
          setrefsterilise(
            res.data.data.sterilise ? res.data.data.sterilise : "NON"
          );
          setrefColor(res.data.data.color ? res.data.data.color : "N/A");
          setrefmicroship(
            res.data.data.microship ? res.data.data.microship : ""
          );
          setrefWeight(res.data.data.weight ? res.data.data.weight : "N/A");
          setrefAliName(
            res.data.data.alimentation ? res.data.data.alimentation : "N/A"
          );
          setrefInsurance(
            res.data.data.insurance_name ? res.data.data.insurance_name : "N/A"
          );
          setrefgoOutSide(
            res.data.data.mode_de_vie ? res.data.data.mode_de_vie : "NON"
          );
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };
  const getpetFiles = () => {
    AXIOS_GET(`${GET_PET_FILE_URL}${id}`, token)
      .then((res) => {
        setfilesData(res.data.data);
      })
      .catch((e) => {});
  };
  useEffect(() => {
    getpetDadata();
    getpetFiles();
  }, []);

  const backPage = () => {
    navigate("/dashboard/pets");
  };
  const downloadFile = (path, fileName) => {
    setisDownload(true);
    fetch(GET_DOWNLOAD_FILE_URL + path, {
      method: "GET",
      headers: { Authorization: "Bearer " + token },
    })
      .then((response) => response.blob())
      .then((blob) => {
        setisDownload(false);
        FileSaver.saveAs(blob, fileName);
      });
  };
  const switchTab = (e) => {
    document.querySelectorAll(".btn_form_switch").forEach((btn) => {
      if (btn === e.target) {
        btn.classList.add("activebtn");
        getpetDadata();
        getpetFiles();
      } else {
        btn.classList.remove("activebtn");
        getpetDadata();
        getpetFiles();
      }
    });
  };
  return (
    <div className="pet_info_container">
      <ToastContainer />
      <div className="pet_info">
        <div className="pet_info_back" onClick={backPage}>
          <Back></Back>
          <span>
            <Translate Word="page.pets.back"></Translate>
          </span>
        </div>
        <div className="pet_info_body">
          <h1>
            <Translate Word="page.pets.info"></Translate>
          </h1>
          <form disabled>
            <div className="imageUploader">
              <div className="img_container">
                {imgUrlPrev ? (
                  <img src={imgUrlPrev} alt="" />
                ) : (
                  <img src={AddImage} alt="" />
                )}
              </div>
              <button
                type="button"
                onClick={() => navigate(`/dashboard/pets/edit/${id}`)}
                className="edit_after_view"
              >
                <Edit></Edit> <Translate Word="page.pets.editPet" />
              </button>
              <div className="frmSwitcher">
                <button
                  type="button"
                  className="btn_form_switch activebtn"
                  onClick={(e) => {
                    setisFile(false);
                    switchTab(e);
                  }}
                >
                  <Translate Word="page.pet.general" />
                </button>
                <button
                  type="button"
                  className="btn_form_switch"
                  onClick={(e) => {
                    setisFile("file");
                    switchTab(e);
                  }}
                >
                  <Translate Word="page.pet.files" />
                </button>
                <button
                  type="button"
                  className="btn_form_switch"
                  onClick={(e) => {
                    setisFile("upload");
                    switchTab(e);
                  }}
                >
                  <Translate Word="page.pet.upload" />
                </button>
              </div>
            </div>

            {!isFile && (
              <>
                {petDataResponse.length <= 0 ? (
                  <SkeletonTheme baseColor="#f7f7f7" highlightColor="#d3d3d3">
                    <div className="singleInput">
                      <Skeleton />
                    </div>
                    <div className="singleInput">
                      <Skeleton />
                    </div>
                    <div className="singleInput">
                      <Skeleton />
                    </div>
                    <div className="singleInput">
                      <Skeleton />
                    </div>
                    <div className="singleInput">
                      <Skeleton />
                    </div>
                    <div className="singleInput">
                      <Skeleton />
                    </div>
                    <div className="singleInput">
                      <Skeleton />
                    </div>
                    <div className="singleInput">
                      <Skeleton />
                    </div>
                    <div className="singleInput">
                      <Skeleton />
                    </div>
                  </SkeletonTheme>
                ) : (
                  <>
                    <div className="columnContainer">
                      <div className="column">
                        <div className="singleInput">
                          <label htmlFor="petName">
                            <Translate Word="page.pets.Petname"></Translate>
                          </label>
                          <input
                            type="text"
                            id="PetName"
                            value={refName}
                            disabled
                          />
                        </div>
                        <div className="singleInput">
                          <label htmlFor="petName">
                            <Translate Word="page.pets.Type"></Translate>
                          </label>
                          <select disabled value={refType}>
                            <option value="" disabled>
                              <Translate Word="page.pets.typeOfpet"></Translate>
                            </option>
                            <option value="CT">
                              <Translate Word="page.type.CT"></Translate>
                            </option>
                            <option value="CN">
                              <Translate Word="page.type.CN"></Translate>
                            </option>
                            <option value="LP">
                              <Translate Word="page.type.LP"></Translate>
                            </option>
                            <option value="GP">
                              <Translate Word="page.type.GP"></Translate>
                            </option>
                            <option value="OI">
                              <Translate Word="page.type.OI"></Translate>
                            </option>
                            <option value="HAM">
                              <Translate Word="page.type.HAM"></Translate>
                            </option>
                            <option value="REP">
                              <Translate Word="page.type.REP"></Translate>
                            </option>
                            <option value="NAC">
                              <Translate Word="page.type.NAC"></Translate>
                            </option>
                          </select>
                        </div>
                        <div className="singleInput">
                          <label htmlFor="">
                            <Translate Word="page.pets.Spayed"></Translate>
                          </label>
                          <select disabled value={refsterilise}>
                            <option value="OUI">
                              <Translate Word="page.general.yes"></Translate>
                            </option>
                            <option value="NON">
                              <Translate Word="page.general.no"></Translate>
                            </option>
                          </select>
                        </div>
                        {hostname != "evc.clinic" && (
                          <>
                            <div className="singleInput">
                              <label htmlFor="petName">
                                <Translate Word="page.pets.VacinationDate"></Translate>
                              </label>
                              <input
                                disabled
                                type="date"
                                id="PetName"
                                value={refVacine}
                                placeholder="Vacination Date"
                              />
                            </div>
                            <div className="singleInput">
                              <label htmlFor="petName">
                                <Translate Word="page.pets.IdentificationDate"></Translate>
                              </label>
                              <input
                                disabled
                                type="date"
                                id="PetName"
                                value={refIdentDate}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      <div className="column">
                        <div className="singleInput">
                          <label htmlFor="petName">
                            <Translate Word="page.pets.birth"></Translate>
                          </label>
                          <input
                            type="date"
                            id="PetName"
                            disabled
                            value={refBirth}
                            placeholder="Date of birth"
                          />
                        </div>
                        <div className="singleInput">
                          <lel htmlFor="petName">
                            <Translate Word="page.pets.breed"></Translate>
                          </lel>
                          <input
                            type="text"
                            id="PetName"
                            disabled
                            value={refBreed}
                            placeholder="Enter Breed"
                          />
                        </div>
                        <div className="singleInput">
                          <label htmlFor="petName">
                            <Translate Word="page.pets.Color"></Translate>
                          </label>
                          <input
                            type="text"
                            id="PetName"
                            disabled
                            value={refColor}
                            placeholder="Enter color"
                          />
                        </div>
                        {hostname != "evc.clinic" && (
                          <div className="singleInput">
                            <label htmlFor="petName">
                              <Translate Word="page.pets.RabbiesBoaster"></Translate>
                            </label>
                            <input
                              disabled
                              type="date"
                              id="PetName"
                              value={refRage}
                              placeholder="Rabbies Booster Date"
                            />
                          </div>
                        )}

                        <div className="singleInput">
                          <label htmlFor="petName">
                            <Translate Word="page.pets.Microship"></Translate>
                          </label>
                          <input
                            disabled
                            type="text"
                            id="PetName"
                            value={refmicroship}
                            placeholder={
                              refmicroship === ""
                                ? languageValue === "En"
                                  ? "The clinic will enter the microship number"
                                  : "votre clinique complètera le numéro de microship"
                                : "Microchip"
                            }
                          />
                        </div>
                      </div>
                      <div className="column">
                        <div className="singleInput">
                          <label htmlFor="petName">
                            <Translate Word="page.pets.Weight"></Translate>
                          </label>
                          <input
                            disabled
                            type="text"
                            id="PetName"
                            value={refWeight}
                            placeholder="Weight"
                          />
                        </div>
                        <div className="singleInput">
                          <label htmlFor="petName">
                            <Translate Word="page.pets.sex"></Translate>
                          </label>
                          <select
                            type="text"
                            value={refSex}
                            disabled
                            placeholder="Enter sex"
                          >
                            <option value="M">
                              <Translate Word="page.general.male"></Translate>
                            </option>
                            <option value="F">
                              <Translate Word="page.general.female"></Translate>
                            </option>
                          </select>
                        </div>
                        {hostname != "evc.clinic" && (
                          <div className="singleInput">
                            <label htmlFor="petName">
                              <Translate Word="page.pets.Alimentation"></Translate>
                            </label>
                            <input
                              disabled
                              type="text"
                              id="PetName"
                              value={refAliName}
                              placeholder="Alimentation's name"
                            />
                          </div>
                        )}

                        {refType != "CT" && hostname != "evc.clinic" && (
                          <div className="singleInput">
                            <label htmlFor="">
                              <Translate Word="page.pets.Goesoutside"></Translate>
                            </label>
                            <select disabled value={refgoOutSide}>
                              <option value="yes">
                                <Translate Word="page.general.yes"></Translate>
                              </option>
                              <option value="no">
                                <Translate Word="page.general.no"></Translate>
                              </option>
                            </select>
                          </div>
                        )}

                        <div className="singleInput">
                          <label htmlFor="">
                            <Translate Word="page.pets.IsInsured"></Translate>
                          </label>
                          <select disabled value={refisInsured}>
                            <option value=""></option>
                            <option value="OUI">
                              <Translate Word="page.general.yes"></Translate>
                            </option>
                            <option value="NON">
                              <Translate Word="page.general.no"></Translate>
                            </option>
                          </select>
                        </div>
                        {IsInsured == "OUI" && (
                          <div className="singleInput">
                            <label htmlFor="petName">
                              <Translate Word="page.pets.Insurancename"></Translate>
                            </label>
                            <input
                              disabled
                              type="text"
                              id="PetName"
                              value={refInsurance}
                              placeholder={languageValue === "En" ? "Insurance name" : "Nom de l'assurance"}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
            {isFile === "file" && (
              <ul className="filesLists">
                {filesData?.length ? (
                  <>
                    {" "}
                    {filesData.map((filed) => {
                      return (
                        <li key={filed.pet_id}>
                          <InsertDriveFileIcon />
                          <h6>{filed.filename}</h6>
                          <button
                            className="downloadBtn"
                            type="button"
                            onClick={() =>
                              downloadFile(filed.file_path, filed.filename)
                            }
                          >
                            <DownloadIcon></DownloadIcon>
                          </button>
                        </li>
                      );
                    })}
                  </>
                ) : (
                  <li>
                    <div></div>
                    <h6>
                      <Translate Word="page.pet.Nofiles" />
                    </h6>
                    <div></div>
                  </li>
                )}
              </ul>
            )}
         {isFile === "upload" && uppy && (
  <Dashboard height={400} uppy={uppy} plugins={[]} />
)}
          </form>
        </div>
        <div className=""></div>
      </div>
    </div>
  );
};

export default AddNew;
